import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import AttendanceGraph from "./AttendanceGraph";
import AttendanceTable from "./AttendanceTable";
import PayRoll from "./PayRoll";
import BASE_URL from "../../context/AppConfig";
Chart.register(...registerables); 

const AdminDashboard = () => {
  const [payrollData, setPayrollData] = useState([]);

  const handleDownload = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/export_payroll_csv/`, {
        responseType: "blob", // Ensures the response is treated as a file
      });

      // Create a URL for the CSV file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "payroll_report.csv"); // Filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Cleanup

    } catch (error) {
      console.error("Error downloading CSV:", error);
    }
  };

  useEffect(() => {
    fetchPayrollData();
  }, []);

  const fetchPayrollData = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(`${BASE_URL}/process_payroll/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPayrollData(response.data.report);
    } catch (error) {
      console.error("Error fetching payroll data:", error);
    }
  };

  const chartData = {
    labels: payrollData.map((entry) => entry.worker),
    datasets: [
      {
        label: "Wages Paid",
        data: payrollData.map((entry) => entry.total_wage),
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
    ],
  };

  return (
    <div className="container">
      <h2>Admin Payroll Dashboard</h2>
      <button className="btn btn-primary btn-sm" onClick={handleDownload}>
      Download Payroll Report
    </button>
    <AttendanceTable/>
    <AttendanceGraph/>
    <PayRoll/>
      
    </div>
  );
};

export default AdminDashboard;
